import { gql } from '@apollo/client'

export const GET_PAGE_LINKS_QUERY = gql`
  query getPageLinks(
    $filter: markets_filter
    $translations_filter: pages_translations_filter
    $pages_filter: pages_filter
  ) {
    markets(filter: $filter) {
      code
      pages {
        pages_id(filter: $pages_filter) {
          meta_title
          slug
          translations(filter: $translations_filter) {
            meta_title
            slug
          }
        }
      }
    }
  }
`
